(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["claudebeforeafter"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sliders = document.querySelectorAll('[data-bap-slider]');
  if (!sliders.length) return;

  sliders.forEach(init);

  function init(slider) {
    const before = slider.querySelector('[data-bap-before]');
    const handle = slider.querySelector('[data-bap-handle]');

    if (!handle) return;

    let dragging = false;
    let activePointerId = null;

    const set = (pct) => {
      pct = Math.max(0, Math.min(100, pct));

      if (before) {
        before.style.clipPath =
          'inset(0 ' + (100 - pct) + '% 0 0)';
      }

      handle.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', Math.round(pct));
    };

    const pctFrom = (e) => {
      const rect = slider.getBoundingClientRect();
      const x = e.clientX - rect.left;

      return (x / rect.width) * 100;
    };

    const down = (e) => {
      dragging = true;
      activePointerId = e.pointerId;

      if (handle.setPointerCapture) {
        try {
          handle.setPointerCapture(e.pointerId);
        } catch (error) {}
      }

      set(pctFrom(e));

      if (e.cancelable) {
        e.preventDefault();
      }
    };

    const move = (e) => {
      if (!dragging) return;

      if (
        activePointerId !== null &&
        e.pointerId !== activePointerId
      ) {
        return;
      }

      set(pctFrom(e));

      if (e.cancelable) {
        e.preventDefault();
      }
    };

    const up = (e) => {
      dragging = false;

      if (
        handle.releasePointerCapture &&
        activePointerId !== null &&
        handle.hasPointerCapture &&
        handle.hasPointerCapture(activePointerId)
      ) {
        try {
          handle.releasePointerCapture(activePointerId);
        } catch (error) {}
      }

      activePointerId = null;
    };

    /*
      The slider starts moving only when the user
      grabs the white line or center circle.
    */
    handle.addEventListener('pointerdown', down);
    handle.addEventListener('pointermove', move);
    handle.addEventListener('pointerup', up);
    handle.addEventListener('pointercancel', up);

    slider.addEventListener('keydown', (e) => {
      const cur =
        parseFloat(handle.getAttribute('aria-valuenow')) || 50;

      if (e.key === 'ArrowLeft') {
        set(cur - 5);
        e.preventDefault();
      }

      if (e.key === 'ArrowRight') {
        set(cur + 5);
        e.preventDefault();
      }

      if (e.key === 'Home') {
        set(0);
        e.preventDefault();
      }

      if (e.key === 'End') {
        set(100);
        e.preventDefault();
      }
    });

    set(50);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
